import {
  Badge,
  Banner,
  BlockStack,
  Box,
  Card,
  Checkbox,
  FormLayout,
  InlineGrid,
  InlineStack,
  Text,
  TextField,
} from '@shopify/polaris';

export interface ABTestCardProps {
  enabled: boolean;
  title: string;
  body: string;
  titleB: string;
  bodyB: string;
  splitA: string;
  titleMax: number;
  bodyMax: number;
  onEnabledChange: (v: boolean) => void;
  onTitleBChange: (v: string) => void;
  onBodyBChange: (v: string) => void;
  onSplitAChange: (v: string) => void;
}

export function ABTestCard(props: ABTestCardProps) {
  const {
    enabled,
    title,
    body,
    titleB,
    bodyB,
    splitA,
    titleMax,
    bodyMax,
    onEnabledChange,
    onTitleBChange,
    onBodyBChange,
    onSplitAChange,
  } = props;

  const splitANum = Number(splitA) || 0;
  const splitBNum = 100 - splitANum;

  return (
    <Card>
      <BlockStack gap="400">
        <InlineStack align="space-between" blockAlign="center">
          <BlockStack gap="050">
            <InlineStack gap="200" blockAlign="center">
              <Text as="h2" variant="headingMd">
                A/B Test
              </Text>
              <Badge tone="attention">اختياري</Badge>
            </InlineStack>
            <Text as="p" variant="bodySm" tone="subdued">
              ابعت 2 variants لنفس الجمهور بـ split عشوائي وشوف أنهي أحسن
            </Text>
          </BlockStack>
          <Checkbox label="فعّل A/B" labelHidden checked={enabled} onChange={onEnabledChange} />
        </InlineStack>

        {enabled ? (
          <FormLayout>
            <Banner tone="info">
              <p>
                هتبعت 2 variants لنفس الـ audience. الصورة + الـ target + الـ audience مشتركين بين الاتنين.
              </p>
            </Banner>

            <InlineGrid columns={{ xs: 1, sm: 2 }} gap="400">
              <Box
                padding="400"
                borderRadius="200"
                background="bg-surface-secondary"
                borderColor="border"
                borderWidth="025"
              >
                <BlockStack gap="200">
                  <InlineStack gap="200" blockAlign="center">
                    <Badge tone="info">Variant A</Badge>
                    <Text as="span" variant="bodySm" tone="subdued">
                      {splitANum}%
                    </Text>
                  </InlineStack>
                  <Text as="p" variant="bodySm">
                    Title: <strong>{title || '— املأ Title فوق —'}</strong>
                  </Text>
                  <Text as="p" variant="bodySm">
                    Body: {body ? body.slice(0, 80) + (body.length > 80 ? '…' : '') : '— املأ Body فوق —'}
                  </Text>
                </BlockStack>
              </Box>

              <Box
                padding="400"
                borderRadius="200"
                background="bg-surface-secondary"
                borderColor="border"
                borderWidth="025"
              >
                <BlockStack gap="300">
                  <InlineStack gap="200" blockAlign="center">
                    <Badge tone="success">Variant B</Badge>
                    <Text as="span" variant="bodySm" tone="subdued">
                      {splitBNum}%
                    </Text>
                  </InlineStack>
                  <TextField
                    label="Title"
                    value={titleB}
                    onChange={onTitleBChange}
                    autoComplete="off"
                    maxLength={titleMax}
                    showCharacterCount
                  />
                  <TextField
                    label="Body"
                    value={bodyB}
                    onChange={onBodyBChange}
                    autoComplete="off"
                    multiline={2}
                    maxLength={bodyMax}
                    showCharacterCount
                  />
                </BlockStack>
              </Box>
            </InlineGrid>

            <TextField
              label="نسبة Variant A"
              type="number"
              value={splitA}
              onChange={onSplitAChange}
              autoComplete="off"
              min={1}
              max={99}
              suffix="%"
              helpText={`A = ${splitANum}% · B = ${splitBNum}%`}
            />
          </FormLayout>
        ) : null}
      </BlockStack>
    </Card>
  );
}
